import { render, staticRenderFns } from "./inventoryOrderDetailWithOutAI.vue?vue&type=template&id=d8845f7c&scoped=true&"
import script from "./inventoryOrderDetailWithOutAI.vue?vue&type=script&lang=js&"
export * from "./inventoryOrderDetailWithOutAI.vue?vue&type=script&lang=js&"
import style0 from "./inventoryOrderDetailWithOutAI.vue?vue&type=style&index=0&id=d8845f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8845f7c",
  null
  
)

export default component.exports